import axios from 'axios';
import { toast } from 'sonner';
import { restoreAfterPreview, restoreExpiredPreviewStash, stashForPreview } from './accountDataPrivacy';

// Founder Preview Mode transport: adds the signed preview token to every backend call while a preview is active.
const KEY = 'shs.founder_preview.v1';
const API = process.env.REACT_APP_BACKEND_URL;
export const PREVIEW_EVENT = 'shs:founder-preview-changed';

export const getPreview = () => {
  try {
    const p = JSON.parse(sessionStorage.getItem(KEY));
    return p && new Date(p.expires_at) > new Date() ? p : null;
  } catch { return null; }
};
export const savePreview = (p) => { stashForPreview(p.expires_at); sessionStorage.setItem(KEY, JSON.stringify(p)); window.dispatchEvent(new Event(PREVIEW_EVENT)); };
export const rawPreview = () => { try { return JSON.parse(sessionStorage.getItem(KEY)); } catch { return null; } };
export const clearPreview = () => { sessionStorage.removeItem(KEY); restoreAfterPreview(); window.dispatchEvent(new Event(PREVIEW_EVENT)); };
// Sign-out during a preview: end it on the server (best effort) and drop the marker so the next account is never affected.
export const abandonPreview = (authToken) => {
  const raw = rawPreview();
  if (!raw) return;
  if (authToken) fetch(`${API}/api/admin/founder-preview/end`, { method: 'POST', keepalive: true, headers: { Authorization: `Bearer ${authToken}`, 'X-SHS-Preview': raw.token } }).catch(() => {});
  sessionStorage.removeItem(KEY);
  window.dispatchEvent(new Event(PREVIEW_EVENT));
};

const isApi = (url) => typeof url === 'string' && API && url.startsWith(`${API}/api/`);
const es = () => localStorage.getItem('language') === 'es';

const onPreviewError = (status, detail) => {
  const code = detail && detail.code;
  if (status === 401 && code === 'preview_expired' && sessionStorage.getItem(KEY)) {
    clearPreview();
    toast.info(es() ? 'La Vista previa del Fundador terminó.' : 'Founder Preview ended.');
    window.location.assign('/admin');
  } else if (status === 403 && (code === 'preview_read_only' || code === 'preview_admin_blocked')) {
    toast.info(es() ? detail.message_es : detail.message_en, { id: code });
  }
};

let installed = false;
export const installPreviewTransport = () => {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  if (!rawPreview()) restoreExpiredPreviewStash();
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input && input.url;
    const p = getPreview();
    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
    // Only the Founder's authenticated calls carry the preview; anonymous/public calls are untouched.
    if (!p || !isApi(url) || !headers.has('Authorization') || headers.has('X-SHS-Preview')) return nativeFetch(input, init);
    headers.set('X-SHS-Preview', p.token);
    const res = await nativeFetch(input, { ...init, headers });
    if (res.status === 401 || res.status === 403) {
      const body = await res.clone().json().catch(() => null);
      const detail = body && body.detail;
      onPreviewError(res.status, detail);
      // Preview ended: replay the call as the Founder's normal session so the app never treats it as a logout.
      if (res.status === 401 && detail && detail.code === 'preview_expired') {
        headers.delete('X-SHS-Preview');
        return nativeFetch(input, { ...init, headers });
      }
    }
    return res;
  };
  axios.interceptors.request.use((cfg) => {
    const p = getPreview();
    const h = cfg.headers || {};
    const authed = typeof h.get === 'function' ? Boolean(h.get('Authorization')) : Boolean(h.Authorization || h.authorization);
    if (p && isApi(cfg.url) && authed) {
      if (typeof h.set === 'function') h.set('X-SHS-Preview', p.token); else cfg.headers = { ...h, 'X-SHS-Preview': p.token };
    }
    return cfg;
  });
  axios.interceptors.response.use((r) => r, (err) => {
    if (err.response) onPreviewError(err.response.status, err.response.data && err.response.data.detail);
    return Promise.reject(err);
  });
};
